import React, {Component} from 'react';

class StateViewer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            expanded: Boolean(props.startExpanded),
        };
    }

    render() {
        return (
            <div className={`state-viewer ${this.state.expanded ? 'expanded' : 'collapsed'}`}>
                <pre>
                    {JSON.stringify(this.props.value, null, 2)}
                </pre>
                <div className='expander' onClick={() => this.setState({expanded: !this.state.expanded})} />
            </div>
        );
    }
}

export default StateViewer;
